import { z } from 'zod';

/** Form schema — reused by the resolver. Amount is a string from the input, parsed on submit. */
export const addExpenseSchema = z.object({
  description: z.string().trim().min(1, 'Enter a description').max(140, 'Too long'),
  amount: z
    .string()
    .trim()
    .regex(/^\d+(\.\d{1,2})?$/, 'Enter a valid amount, e.g. 12.50')
    .refine((v) => Number.parseFloat(v) > 0, 'Amount must be greater than 0'),
});

export type AddExpenseValues = z.infer<typeof addExpenseSchema>;
